import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { PersonaDetailType } from '@dis/types/src/PersonaTypes'

type PersonasReducerState = {
  callback: {
    atlasId?: number
    folderId?: number
    journeyId?: number
  }
  historyVersionPreviewMode?: 'backForward' | 'time' | undefined
  isBackEnable: boolean
  isForwardEnable: boolean
  isHistoryVersionPreview: boolean
  isNew: boolean
  personaId?: number
  personaSelectedVersionData?: PersonaDetailType
  version?: number
}

const initialState: PersonasReducerState = {
  callback: {},
  historyVersionPreviewMode: undefined,
  isBackEnable: false,
  isForwardEnable: false,
  isHistoryVersionPreview: false,
  isNew: false,
  personaId: undefined,
  personaSelectedVersionData: undefined,
}

export const personasSlice = createSlice({
  initialState,
  name: 'personas',
  reducers: {
    init: () => initialState,
    setCallback: (state, action: PayloadAction<PersonasReducerState['callback']>) => {
      state.callback = action.payload
    },
    setHistoryVersionPreviewMode: (
      state,
      action: PayloadAction<'backForward' | 'time' | undefined>,
    ) => {
      state.historyVersionPreviewMode = action.payload
    },
    setIsBackEnable: (state, action: PayloadAction<boolean>) => {
      state.isBackEnable = action.payload
    },
    setIsForwardEnable: (state, action: PayloadAction<boolean>) => {
      state.isForwardEnable = action.payload
    },
    setIsHistoryVersionPreview: (state, action: PayloadAction<boolean>) => {
      state.isHistoryVersionPreview = action.payload
    },
    setNewPersona: (state) => {
      state.isNew = true
    },
    setPersonaId: (state, action: PayloadAction<number | undefined>) => {
      state.personaId = action.payload
    },
    setPersonaSelectedVersionData: (
      state,
      action: PayloadAction<PersonaDetailType | undefined>,
    ) => {
      state.personaSelectedVersionData = action.payload
    },
    setPersonaVersion: (state, action: PayloadAction<number | undefined>) => {
      state.version = action.payload
    },
  },
})
